const USER_TOKEN_KEY = "lealti_search_user_token";
const SESSION_ID_KEY = "lealti_search_session_id";

const getStorage = (type: "local" | "session") => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return type === "local" ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
};

const generateId = () => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `sid_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
};

export const shouldTrackSearch = () => {
  if (typeof navigator === "undefined") return false;
  const dnt = navigator.doNotTrack || (window as any).doNotTrack || (navigator as any).msDoNotTrack;
  return String(dnt || "0") !== "1";
};

export const getSearchUserToken = () => {
  const storage = getStorage("local");
  if (!storage) return "";
  const existing = storage.getItem(USER_TOKEN_KEY);
  if (existing) return existing;
  const created = generateId();
  storage.setItem(USER_TOKEN_KEY, created);
  return created;
};

export const getSearchSessionId = () => {
  const storage = getStorage("session");
  if (!storage) return "";
  const existing = storage.getItem(SESSION_ID_KEY);
  if (existing) return existing;
  const created = generateId();
  storage.setItem(SESSION_ID_KEY, created);
  return created;
};

export const getSearchContext = () => {
  if (typeof window === "undefined") {
    return { sessionId: "", userToken: "", platform: "web" as const };
  }
  return {
    sessionId: getSearchSessionId(),
    userToken: getSearchUserToken(),
    platform: "web" as const,
  };
};
